define('model/workflow.task.model',['require','exports','module','underscore','datakit/datakit','backbone.radio','./base.workflow.model'],function(require, exports, module) {
  //prettier-ignore
  var _                 = require('underscore'),
      DataKit           = require('datakit/datakit'),
      Radio             = require('backbone.radio'),
      BaseWorkflowModel = require('./base.workflow.model'),

      //Radio channels
      UIChannel = Radio.channel('UIChannel');

  // Check docs in docs/workflow.task.model.md

  function getLocalTaskVariableDataFromTask(taskModel) {
    var localTaskVariable = _.find(taskModel.get('variables'), function(variable) {
      return variable.name == 'localTaskVariables';
    });
    try {
      return JSON.parse(localTaskVariable.value);
    } catch (e) {
      return {};
    }
  }

  var WorkflowTaskModel = BaseWorkflowModel.extend({
    radioRequests: {
      'models WorkflowTaskModel': '@constructor',
    },

    initialize: function() {
      BaseWorkflowModel.prototype.initialize.apply(this, arguments);

      this.on('error', function() {
        UIChannel.request('proposal:ui:reset');
      })
    },

    urlRoot: '/api/v1/coi-workflow/runtime/tasks',

    parse: function(resp, options) {
      return {
        variables: null,
      };
    },

    virtual: {
      documentId: function(attr) {
        var variable = _.find(
          this.get('variables'),
          function(variable) {
            return variable.name == attr;
          },
          this
        );
        if (variable) {
          return variable.value;
        }
      },
    },

    relationshipTypes: {
      hasOne: DataKit.AbstractHasOneRelationshipType.extend({
        initialize: function() {
          DataKit.AbstractHasOneRelationshipType.prototype.initialize.apply(this, arguments);
          this.queryCollection = new WorkflowTaskModel.QueryCollection();
        },
        configureResource: function() {
          this.queryCollection.requestBodyQueryModel.set({
            includeTaskLocalVariables: true,
            processInstanceVariables: [
              {
                name: this.foreignKey,
                operation: 'equals',
                value: this.foreignModel.id,
              },
            ],
          });
        },
        fetchResource: function() {
          return this.queryCollection.fetch();
        },
        onFetchSuccess: function() {
          if (this.queryCollection.isEmpty()) {
            this.resource.clear();
          } else {
            this.resource.set(this.queryCollection.first().attributes);
          }
        },
      }),
    },

    completeTaskWithRoutingAction: function(routingAction) {
      return this.completeTask([
        {
          name: this.get('taskDefinitionKey'),
          value: routingAction.get('routingId'),
        },
      ]);
    },

    completeTask: function(variables) {
      if (variables && !_.isArray(variables)) {
        variables = [variables];
      }
      return this.invokeAction({
        action: 'complete',
        variables: variables || [],
      });
    },

    invokeAction: function(attrs) {
      return this.save(
        {},
        {
          type: 'POST',
          attrs: attrs,
        }
      );
    },

    relationships: {
      formDataModel: {
        type: 'hasOne',
        foreignKey: 'taskId',
        resourceClass: 'WorkflowFormDataModel',
      },
      localVariableCollection: {
        // included in response of workflow task model
        type: 'extracted',
        extract: function(model) {
          return model.get('variables');
        },
        resourceClass: Backbone.Collection,
      },
      requiredActivityCollection: {
        // included in response of workflow task model
        type: 'extracted',
        extract: function(model) {
          var localTaskVariableData = getLocalTaskVariableDataFromTask(model);
          return _.result(localTaskVariableData, 'requiredActivities') || [];
        },
        onSync: function(relationship, workflowTaskModel, options) {
          relationship.resource.determineTaskActivityCompletion();
        },
        resourceClass: Backbone.Collection.extend({
          determineTaskActivityCompletion: function() {
            Radio.request('workflowActivityService', 'determineTaskActivityCompletion', this);
          },
        }),
      },
      disclosureModel: {
        type: 'belongsTo',
        foreignKey: 'documentId',
        resourceClass: 'DisclosureDetailModel',
      },
    },
  });

  WorkflowTaskModel.QueryCollection = WorkflowTaskModel.Collection.extend({
    url: '/api/v1/coi-workflow/query/mytasks',

    relationshipTypes: {
      hasMany: DataKit.RelationshipType,
    },

    initialize: function(models, options) {
      WorkflowTaskModel.Collection.prototype.initialize.apply(this, arguments);

      this.requestBodyQueryModel = new Backbone.Model(_.result(options, 'requestBody'));
    },

    fetch: function() {
      return WorkflowTaskModel.Collection.prototype.fetch.call(this, {
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify(this.requestBodyQueryModel),
      });
    },
  });

  module.exports = WorkflowTaskModel;
});

